import React, { useEffect, useState, useRef } from "react";
import { ASSETS } from "../../utils/config";
import CreateTimeWheelChart from "../D3Wheels/create-time-wheel";
import CustomTimePicker from "../CustomTimePicker";
import { hexToRgb } from "@material-ui/core";
import moment from "moment";
import _ from "lodash";

const TimeWheelComponent = ({ size = 500 }) => {
  const parentRef = useRef(null);
  const [pieInstance, setPieInstance] = useState(null);
  const isViewMode = false;

  let [chartData, setData] = useState([
    // { "start_time": "02:00:00", "end_time": "03:00:00", "id": "020000", "color": "#fa6b73", "degrees": 15, "value": 60, "selected": true },
    // { "start_time": "03:00:00", "end_time": "04:00:00", "id": "030000", "color": "##e0c482", "degrees": 15, "value": 60 }
  ]);

  const userData = {
    id: 1,
    url: "http://juantxocruz.com/wp-content/uploads/Humphrey_Bogart.jpg",
  };

  const containerStyle = {
    position: "relative",
    height: size,
    width: size,
  };

  const wheelStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: size * 0.76, // Adjusted proportionally to the size
    height: size * 0.76, // Adjusted proportionally to the size
    zIndex: 20,
  };

  const imageContainerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
  };

  const d = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  };

  const timePickerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2000,
  };

  const updateSize = () => {
    if (pieInstance) {
      pieInstance.setSvg();
      pieInstance.updateArcs(pieInstance.chartData);
    }
  };

  const debouncerListener = _.debounce(function (e) {
    updateSize();
  }, 300);

  window.addEventListener("resize", debouncerListener, false);

  useEffect(() => {
    const maxSelectedArcs = 1;

    const getSelectedArcs = (selectedData) => {
      console.log("selectedData", selectedData);
    };

    const arcHover = (hoverEvents) => {
      // console.log('hover', hoverEvents)
    };

    const showLabels = false;

    if (pieInstance) {
      console.log("chart data chala");
      pieInstance.setMode(isViewMode);
      pieInstance.updateArcs(chartData);
      pieInstance.manageLabels(showLabels);
    } else {
      const instance = new CreateTimeWheelChart(
        parentRef.current,
        chartData,
        userData,
        setData,
        isViewMode,
        getSelectedArcs,
        maxSelectedArcs,
        arcHover
      );
      setPieInstance(instance);
    }
  }, [parentRef.current, chartData, userData, isViewMode]);

  const [fromTime, setFromTime] = useState(moment().startOf("day"));
  const [tillTime, setTillTime] = useState(
    moment().startOf("day").add(15, "minutes")
  );
  const isOnlyFifteenMinutesDifference =
    tillTime.diff(fromTime, "minutes") === 15;

  const isTillTimeElevenFiftyNine =
    tillTime.hour() === 23 && tillTime.minute() === 59;
  const maxTillTime = moment().endOf("day");

  const getOpenedArc = () => {
    return chartData.find((arc) => arc.selected);
  };

  const openedArc = getOpenedArc();
  const arcColor = openedArc?.color;

  useEffect(() => {
    const openedArc = getOpenedArc();
    if (openedArc) {
      setFromTime(moment(openedArc.start_time, "HH:mm:ss"));
      setTillTime(moment(openedArc.end_time, "HH:mm:ss"));
    }
  }, [chartData]);

  const handleTimeChange = (time, isIncrementing, isFromTime) => {
    let adjustedTime = moment(time).add(isIncrementing ? 15 : -15, "minutes");

    if (isFromTime) {
      if (
        isIncrementing &&
        adjustedTime.isAfter(moment().endOf("day").subtract(15, "minutes"))
      ) {
        adjustedTime = moment().endOf("day").subtract(15, "minutes");
      }
      if (adjustedTime.isBefore(tillTime)) {
        setFromTime(adjustedTime);

        const updatedChartData = chartData.map((arc) => {
          if (arc.selected) {
            return { ...arc, start_time: adjustedTime.format("HH:mm:ss") };
          }
          return arc;
        });
        setData(updatedChartData);
      }
    } else {
      if (isIncrementing && adjustedTime.isAfter(maxTillTime)) {
        adjustedTime = maxTillTime;
      }
      if (
        adjustedTime.isAfter(fromTime) &&
        adjustedTime.isSameOrBefore(maxTillTime)
      ) {
        setTillTime(adjustedTime);
        // Update chartData for the selected arc
        const updatedChartData = chartData.map((arc) => {
          if (arc.selected) {
            return { ...arc, end_time: adjustedTime.format("HH:mm:ss") };
          }
          return arc;
        });
        setData(updatedChartData);
      }
    }
  };

  // const fromTimeUpDisable = fromTime.isSameOrAfter(tillTime.clone().subtract(15, 'minutes'));
  // const fromTimeDownDisable = fromTime.isSameOrBefore(moment().startOf('day'));
  // const tillTimeUpDisable = tillTime.isSameOrAfter(moment().endOf('day'));
  // const tillTimeDownDisable = tillTime.isSameOrBefore(fromTime.clone().add(15, 'minutes'));

  const selectedIndex = chartData.findIndex((segment) => segment.selected);

  const previousSegment =
    selectedIndex > 0 ? chartData[selectedIndex - 1] : null;
  const nextSegment =
    selectedIndex < chartData.length - 1 ? chartData[selectedIndex + 1] : null;

  // Calculate the disable conditions
  // const fromTimeUpDisable = nextSegment ? tillTime.isSameOrAfter(moment(nextSegment.start_time, 'HH:mm:ss')) : false;
  // const fromTimeDownDisable = previousSegment ? fromTime.isSameOrBefore(moment(previousSegment.end_time, 'HH:mm:ss')) : false;
  // const tillTimeUpDisable = nextSegment ? tillTime.isSameOrAfter(moment(nextSegment.start_time, 'HH:mm:ss')) : false;
  // const tillTimeDownDisable = previousSegment ? tillTime.isSameOrBefore(moment(previousSegment.end_time, 'HH:mm:ss')) : false;

  const fromTimeUpDisable =
    !isTillTimeElevenFiftyNine && // Check if tillTime is not 11:59 PM
    (isOnlyFifteenMinutesDifference ||
      (nextSegment &&
        tillTime.isSameOrAfter(moment(nextSegment.start_time, "HH:mm:ss"))) ||
      tillTime.isSameOrAfter(moment().endOf("day").subtract(1, "minute")));
  const fromTimeDownDisable =
    (previousSegment &&
      fromTime.isSameOrBefore(moment(previousSegment.end_time, "HH:mm:ss"))) ||
    fromTime.isSameOrBefore(moment().startOf("day"));
  const tillTimeUpDisable =
    (nextSegment &&
      tillTime.isSameOrAfter(moment(nextSegment.start_time, "HH:mm:ss"))) ||
    tillTime.isSameOrAfter(moment().endOf("day").subtract(1, "minute"));
  const tillTimeDownDisable =
    isOnlyFifteenMinutesDifference ||
    (previousSegment &&
      tillTime.isSameOrBefore(moment(previousSegment.end_time, "HH:mm:ss"))) ||
    tillTime.isSameOrBefore(moment().startOf("day"));

  // const fromTimeUpDisable = false
  // const fromTimeDownDisable = false
  // const tillTimeUpDisable = false
  // const tillTimeDownDisable = false

  return (
    <>
      <div style={containerStyle}>
        {openedArc && (
          <div style={timePickerStyle}>
            <CustomTimePicker
              bgColor={arcColor}
              fromTime={fromTime}
              tillTime={tillTime}
              handleTimeChange={handleTimeChange}
              fromTimeUpDisable={fromTimeUpDisable}
              fromTimeDownDisable={fromTimeDownDisable}
              tillTimeUpDisable={tillTimeUpDisable}
              tillTimeDownDisable={tillTimeDownDisable}
            />
          </div>
        )}
        <div ref={parentRef} style={wheelStyle}></div>

        <div style={imageContainerStyle}>
          <img
            src={ASSETS.timeClock}
            className="img-fluid"
            alt="Clones"
            style={imageStyle}
          />
        </div>
      </div>
      {/* {<p>{JSON.stringify(chartData)}</p>} */}
    </>
  );
};

export default TimeWheelComponent;
